import { Route } from "react-router-dom";
import App from "./containers/app.js";

const AppEntry = () => <Route path="*" component={App} />;

export default AppEntry;
